<script>
    import { fly, fade } from 'svelte/transition';
    
</script>

<style>
    .BusyLayer {
        position: fixed;
        top: 0;
        left: 300px;
        width: calc(100% - 300px);
        height: 100%;
        background-color:rgba(213, 225, 230, .7);
        z-index: 5;
    }
</style>

<div class="BusyLayer" transition:fade={{ duration: 100 }}></div>